<template>
	<div>
		<el-dialog :visible.sync="dialogShow" width="919px" class="logisticsDialog-box" :close-on-click-modal="true"
			@close="closeDialog">
			<div class="dialog-member-title">
				<span class="dialog-member-name">查看物流</span>
				<div class="dialog-close" @click="dialogShow = false">
					<i class="el-icon-close"></i>
				</div>
			</div>
			<!-- 用户物流信息 -->
			<div class="quan-num-add" v-loading="dataLoading">

				<!-- 收件人信息 -->
				<template v-if="userSend">
					<div class="info_box">
						<!-- 寄收表示 --> 	
						<div class="info_box_left">
							<div class="info_circle">
								寄
							</div>
							<div class="info_box_text">
								<div style="display: flex; align-items: center;">
									<div style="min-width: 4em;">收件人：</div>
									<template>
										<span>{{ defaultData.name + ' ' + defaultData.phone }}</span>
										<el-button type="text" style="margin-left: 20px;" @click="handleCopy(defaultData.name + ' ' + defaultData.phone + ' ' + defaultData.province + defaultData.city +
											defaultData.district + defaultData.address)">复制</el-button>
										<!-- <el-button type="text" style="margin-left: 20px;">修改</el-button>
									<el-button type="text" style="margin-left: 20px;">保存</el-button>
									<el-button type="text" style="margin-left: 20px;">取消</el-button> -->
									</template>
									<!-- <el-input style="width: 80%;" v-show="editSender" v-model="orderItem.exName"
									placeholder="请输入收件人姓名 + 号码"></el-input> -->
								</div>
								<div style="height: 40px;line-height: 40px;display: flex;">
									<div style="min-width: 3em;">地址：<span>{{ defaultData.province + defaultData.city +
										defaultData.district + defaultData.address }}</span></div>
									<!-- <el-input v-show="editSender" v-model="orderItem.exAddress" placeholder="请输入收件人地址"></el-input> -->
								</div>
							</div>
						</div>
						<div class="info_box_right">
							<div style="min-width: 300px;display: flex;align-items: center;">
								快递公司：
								<div style="width: 180px;">
									<span v-show="!editSender">{{ userExpressData.exCompany }}</span>
									<el-select v-show="editSender" v-model="userExpressData.exCompanyCode" filterable clearable
										@change="e => courierChange(e, 'userExpressData')">
										<el-option :label="item.label" :value="item.value" v-for="item in companySuoJson"
											:key="item.value"></el-option>
									</el-select>
								</div>
								<div style="width: 100px;">
									<el-button v-show="!editSender" type="text" style="margin-left: 20px;"
										@click="editSender = true">修改</el-button>
									<el-button v-show="editSender" type="text" style="margin-left: 20px;"
										@click="handleSaveExpress('editSender')">保存</el-button>
									<el-button v-show="editSender" type="text" style="margin-left: 20px;"
										@click="editSender = false">取消</el-button>
								</div>
							</div>
							<div style="display: flex;align-items: center;">
								<div>快递单号：
									<span v-show="!editSender">{{ userExpressData.expressNo }}</span>
									<el-button v-show="!editSender" type="text" style="margin-left: 20px;"
										@click="handleCopy(userExpressData.expressNo)">复制</el-button>
								</div>
								<el-input v-show="editSender" v-model="userExpressData.expressNo" style="width: 180px;"
									placeholder="请输入快递单号"></el-input>

							</div>
						</div>

					</div>
					<el-collapse value="2" style="width: 100%; margin-top: 20px;height: 240px;overflow-y: auto;">
						<el-collapse-item title="物流信息" name="2">
							<template slot="title">
								<i class="header-icon el-icon-truck icon-title" style="font-size: 20px;"></i> 物流信息
							</template>
							<el-steps :space="40" :active="1"
								:finish-status="userExpressData.expressResult && String(userExpressData.expressResult.ischeck)"
								direction="vertical">
								<el-step v-if="!(userExpressData.expressResult && userExpressData.expressResult.com)"
									description="未绑定物流信息哟"></el-step>
								<el-step
									v-else-if="!(userExpressData.expressResult && (userExpressData.expressResult.data || userExpressData.expressResult.data.length == 0))"
									description="亲！ 暂时还没有物流信息哟"></el-step>
								<div v-else>
									<el-step v-for="(item, index) in userExpressData.expressResult.data" :key="index"
										:description="item.Time + '------' + item.Context"></el-step>
								</div>
							</el-steps>
						</el-collapse-item>
					</el-collapse>
				</template>


				<template v-if="userSign">
					<!-- 收件人信息 -->
					<div class="info_box">
						<!-- 寄收表示 -->
						<div class="info_box_left">
							<div class="info_circle">
								收
							</div>
							<div class="info_box_text">
								<div style="display: flex; align-items: center;">
									<div style="min-width: 4em;">收件人：</div>
									<template v-if="!editRecieverAddress">
										<span>{{ userExpressData.recipient + ' ' + userExpressData.phone }}</span>
										<el-button type="text" style="margin-left: 20px;"
											@click="handleCopy(userExpressData.recipient + ' ' + userExpressData.phone + ' ' + userExpressData.address)">复制</el-button>


									</template>
									<el-input style="width: 100px;margin-right: 10px;" v-show="editRecieverAddress"
										v-model="userExpressData.recipient" placeholder="收件人姓名"></el-input>
									<el-input style="width: 140px;" v-show="editRecieverAddress" v-model="userExpressData.phone"
										placeholder="收件人号码"></el-input>
									<el-button type="text" style="margin-left: 20px;" v-show="!editRecieverAddress"
										@click="editRecieverAddress = true">修改</el-button>
									<el-button type="text" style="margin-left: 20px;" v-show="editRecieverAddress"
										@click="handleSaveExpress('editRecieverAddress')">保存</el-button>
									<el-button type="text" style="margin-left: 20px;" v-show="editRecieverAddress"
										@click="editRecieverAddress = false">取消</el-button>
								</div>
								<div style="height: 40px;line-height: 40px;display: flex;">
									<div style="min-width: 3em;">地址：<span v-show="!editRecieverAddress">{{
										userExpressData.address
									}}</span></div>
									<div style="display: flex;gap: 10px;" v-show="editRecieverAddress">
										<div>
											<el-select style="width: 110px;" v-model="userAddressData.userProvince" clearable filterable
												placeholder="请选择省" @change="e => handleChangeArea(e, 'province')">
												<el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.name">
												</el-option>
											</el-select>
										</div>
										<div>
											<el-select style="width: 110px;" v-model="userAddressData.userCity" clearable filterable
												placeholder="请选择市" @change="e => handleChangeArea(e, 'city')">
												<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.name">
												</el-option>
											</el-select>
										</div>
										<div>
											<el-select style="width: 110px;" v-model="userAddressData.userDistrict" clearable filterable
												placeholder="请选择区" @change="e => handleChangeArea(e, 'district')">
												<el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.name">
												</el-option>
											</el-select>
										</div>
									</div>
									<!-- <el-input v-show="editRecieverAddress" v-model="userExpressData.address"
										placeholder="请输入收件人地址"></el-input> -->
								</div>
								<div style="height: 40px;line-height: 40px;display: flex;" v-show="editRecieverAddress">
									<div style="min-width: 5em;">详细地址：</div>
									<el-input style="margin-right: 10px;" v-model="userAddressData.userAddress"
										placeholder="输入详细地址"></el-input>
								</div>
							</div>
						</div>
						<div class="info_box_right">
							<div style="min-width: 300px;display: flex;align-items: center;">
								快递公司：
								<div style="width: 180px;">
									<span v-show="!editReciever">{{ systemExpressData.exCompany }}</span>
									<el-select v-show="editReciever" v-model="systemExpressData.exCompanyCode" filterable clearable
										@change="e => courierChange(e, 'systemExpressData')">
										<el-option :label="item.label" :value="item.value" v-for="item in companySuoJson"
											:key="item.value"></el-option>
									</el-select>
								</div>
								<div style="width: 100px;">
									<el-button v-show="!editReciever" type="text" style="margin-left: 20px;"
										@click="editReciever = true">修改</el-button>
									<el-button v-show="editReciever" type="text" style="margin-left: 20px;"
										@click="handleSaveExpress('editReciever')">保存</el-button>
									<el-button v-show="editReciever" type="text" style="margin-left: 20px;"
										@click="editReciever = false">取消</el-button>
								</div>
							</div>
							<div style="display: flex;align-items: center;">
								<div>快递单号：
									<span v-show="!editReciever">{{ systemExpressData.expressNo }}</span>
									<el-button v-show="!editReciever" type="text" style="margin-left: 20px;"
										@click="handleCopy(systemExpressData.expressNo)">复制</el-button>
								</div>
								<el-input v-show="editReciever" v-model="systemExpressData.expressNo" style="width: 180px;"
									placeholder="请输入快递单号"></el-input>

							</div>
						</div>

					</div>
					<el-collapse value="2" style="width: 100%; margin-top: 20px;height: 240px;overflow-y: auto;">
						<el-collapse-item title="物流信息" name="2">
							<template slot="title">
								<i class="header-icon el-icon-truck icon-title" style="font-size: 20px;"></i> 物流信息
								<!-- <i class="header-icon el-icon-refresh icon-title" style="margin-left: 3rem" @click.stop="getLogisticsFun"></i> -->
							</template>
							<el-steps :space="40" :active="1"
								:finish-status="systemExpressData.expressResult && String(systemExpressData.expressResult.ischeck)"
								direction="vertical">
								<el-step v-if="!(systemExpressData.expressResult && systemExpressData.expressResult.com)"
									description="未绑定物流信息哟"></el-step>
								<el-step
									v-else-if="!(systemExpressData.expressResult && (systemExpressData.expressResult.data || systemExpressData.expressResult.data.length == 0))"
									description="亲！ 暂时还没有物流信息哟"></el-step>
								<div v-else>
									<el-step v-for="(item, index) in systemExpressData.expressResult.data" :key="index"
										:description="item.Time + '------' + item.Context"></el-step>
								</div>
							</el-steps>
						</el-collapse-item>
					</el-collapse>
				</template>
			</div>
			<!-- 回寄物流信息 -->
		</el-dialog>
	</div>
</template>


<script>
import { platformaddresslist, getcitylist } from '@/api/settings'
import { queryexpressorder, queryproductaddress, updatelogisticsinfo, addlogisticsinfo, getorderflow, updateorderaddress } from '@/api/order'

export default {
	props: {
		show: {
			type: Boolean,
			default: false
		},
		PreOrderItem: {
			type: Object,
			default: () => ({})
		},
	},


	data() {
		return {
			dialogShow: false,
			activeName: 'first',
			editSender: false,
			editReciever: false,
			editRecieverAddress: false,
			dataLoading: false,
			dialogData: {
				exCompany: '',
				expressNo: '',
			},
			userAddressData: {
				userProvince: '',
				userCity: '',
				userDistrict: '',
				userAddress: '',
			},
			// 默认地址
			defaultData: {
				name: '',
				phone: '',
				address: '',
				district: '',
				city: '',
				province: '',

				exCompany: '',
				expressNo: '',
			},
			systemExpressData: {
				exCompany: '',
				expressNo: '',
			},
			userExpressData: {
				phone: '',
				recipient: '',
				exCompany: '',
				expressNo: '',
			},
			logisticsRules: {
				exCompany: [
					{ required: true, message: '请选择快递公司', trigger: ['change', 'blur'] }
				],
				expressNo: [
					{ required: true, message: '请填写订单号', trigger: ['change', 'blur'] }
				],
			},
			companySuoJson: [
				{ label: '申通快递', value: 'shentong' },
				{ label: '顺丰快递', value: 'shunfeng' },
				{ label: '韵达快递', value: 'yunda' },
				{ label: '天天快递', value: 'tiantian' },
				{ label: '百世快运', value: 'baishiwuliu' },
				{ label: '圆通快递', value: 'yuntong' },
				{ label: '中通快递', value: 'zhongtong' },
				{ label: 'EMS', value: 'ems' },
				{ label: '优速快递', value: 'youshuwuliu' },
				{ label: '京东快递', value: 'jd' },
				{ label: '德邦物流', value: 'dabangwuliu' },
				{ label: '宅急送', value: 'zhaijisong' },
				{ label: '邮政快递包裹', value: 'youzhengguonei' },
				{ label: '汇通快递', value: 'huitongkuaidi' }
			],
			userSend: false,//需要用户寄送
			userSign: false,//需要用户签收
			areaData: {

			},
			provinceList: [],
			districtList: [],
			cityList: [],
			orderItem: {

			},
		}
	},
	watch: {
		show(val) {
			this.dialogShow = val
			if (val) {
				this.orderItem = { ...this.PreOrderItem }
				this.dialogData = { ...this.PreOrderItem }
				this.userExpressData = {
					phone: this.orderItem.userPhone,
					recipient: this.orderItem.userName,
					address: this.orderItem.userProvince + this.orderItem.userCity + this.orderItem.userDistrict + this.orderItem.userAddress,
				}
				this.userAddressData = {
					userProvince: this.orderItem.userProvince,
					userCity: this.orderItem.userCity,
					userDistrict: this.orderItem.userDistrict,
					userAddress: this.orderItem.userAddress,
				}
				this.getUserExpressData()
				this.getDataList()
				this.handleGetorderflow()
				this.handleGetCityList()
			}
		},
	},
	methods: {
		// 获取地区列表数据
		handleGetCityList() {
			getcitylist().then(res => {
				console.log(res, 'area')
				if (res.code == 1) {
					this.areaData = res.data
					this.provinceList = res.data.province
				}
			})
		},
		// 省份框选择
		handleChangeArea(itemId, key) {
			console.log(itemId, key)
			switch (key) {
				case 'province':
					this.userAddressData['userProvince'] = ''
					this.handleClearCity(true)
					this.handleClearDistrict(true)
					break;
				case 'city':
					this.handleClearCity()
					this.handleClearDistrict(true)
					break;
				case 'district':
					this.handleClearDistrict()
					break;
				default:
					break;
			}
			if (itemId == '') return
			if (key == 'province') {
				let item = this.provinceList.find(item => item.name == itemId)
				this.userAddressData.userProvince = item.name
				this.cityList = this.areaData.city.filter(item2 => {
					return item2.parentId == item.id
				})
			} else if (key == 'city') {
				let item = this.cityList.find(item => item.name == itemId)
				this.userAddressData.userCity = item.name
				this.districtList = this.areaData.district.filter(item2 => {
					return item2.parentId == item.id
				})
			} else if (key == 'district') {
				let item = this.districtList.find(item => item.name == itemId)
				this.userAddressData.userDistrict = item.name
			}
		},
		// 清除市数据
		handleClearCity(flage = false) {
			if (flage) this.cityList = []
			this.userAddressData.userCity = ''
		},
		// 清除区数据
		handleClearDistrict(flage = false) {
			if (flage) this.districtList = []
			this.userAddressData.userDistrict = ''
		},
		handleGetorderflow() {
			// 需要用户寄送资料的
			let needUserSend = ['Send_visa_materials']
			// 需要用户签收资料的
			let needUserSign = ['Train', 'Succeed_Post']
			let dataArr = []
			getorderflow({ orderId: this.orderItem.orderId }).then(res => {
				if (res.code == 1) {
					console.log(res.data)
					dataArr = res.data.map(item => {
						return item.code
					})
					console.log(dataArr)
					// 判断是单独需要用户寄送的还是单独需要用户签收的或者是两者都有
					if (needUserSend.some(item => dataArr.includes(item))) {
						this.userSend = true
					}
					if (needUserSign.some(item => dataArr.includes(item))) {
						this.userSign = true
					}
				}
			})
		},
		async handleCopy(text) {
			if (!text) {
				return
			}
			try {
				// 使用 Clipboard API 写入文本到剪贴板
				await navigator.clipboard.writeText(text);
				// 复制成功提示
				this.$message.success('复制成功');
			} catch (err) {
				// 复制失败处理
				console.error("复制失败:", err);
			}
		},
		handleSaveExpress(key) {
			// 点击上方修改是修改用户的快递单号信息
			let data = {}
			if (key == 'editSender') {
				data = { ...this.userExpressData }
				data = {
					id: this.userExpressData.id,
					orderId: this.orderItem.orderId,
					userId: this.userExpressData.userId,
					expressNo: this.userExpressData.expressNo,
					exCompany: this.userExpressData.exCompany,
					exCompanyCode: this.userExpressData.exCompanyCode,
					recipient: this.userExpressData.recipient,
					phone: this.userExpressData.phone,
					address: this.userExpressData.address,
				}
				data.type = 1
			} else if (key == 'editReciever') {
				// 下方修改存在一种情况 我们先回寄那么就修改不了用户的地址只能先创建一个回寄订单
				console.log(this.systemExpressData, this.defaultData)
				data = {
					...this.systemExpressData,
					recipient: this.userExpressData.recipient,
					phone: this.userExpressData.phone,
					address: this.userExpressData.address,
				}
				data.type = 0
				// 同时修改用户快递信息内容 但是存在我们先寄情况 没有id就不让更新
				let data2 = { ...this.userExpressData }
				if (data2.id) {
					updatelogisticsinfo(data2).then(res => {
					})
				}
			} else if (key == 'editRecieverAddress') {
				let data = {
					...this.userAddressData,
					userName: this.userExpressData.recipient,
					userPhone: this.userExpressData.phone,
					orderId: this.orderItem.id,
				}
				updateorderaddress(data).then(res => {
					if (res.code == 1) {
						this.$message.success('修改成功')
						// 修改临时内容
						this[key] = false
						this.orderItem = {
							...this.orderItem,
							userProvince: this.userAddressData.userProvince,
							userCity: this.userAddressData.userCity,
							userDistrict: this.userAddressData.userDistrict,
							userAddress: this.userAddressData.address,
						}
						this.userExpressData.address = this.userAddressData.userProvince + this.userAddressData.userCity + this.userAddressData.userDistrict + this.userAddressData.userAddress
					}
				})
				return
			}

			if (data.id) {
				updatelogisticsinfo(data).then(res => {
					if (res.code == 1) {
						this.$message.success('修改成功')
						this[key] = false
					}
				}).finally(() => {
					this.getUserExpressData()

				})
			} else {
				// 如果没有id就是创建
				data.orderId = this.orderItem.id
				addlogisticsinfo(data).then(res => {
					if (res.code == 1) {
						this.$message.success('修改成功')
						this[key] = false
					}
				}).finally(() => {
					this.getUserExpressData()
				})
			}

		},
		closeDialog() {
			this.dialogShow = false
			this.$emit('closeDialog')
			this.userExpressData = {
				phone: '',
				recipient: '',
				exCompany: '',
				expressNo: '',
			}
			this.systemExpressData = {
				phone: '',
				recipient: '',
				exCompany: '',
				expressNo: '',
			}
			this.defaultData = {
				name: '',
				phone: '',
				address: '',
				district: '',
				city: '',
				province: '',

				exCompany: '',
				expressNo: '',
			}
			this.userSend = false
			this.userSign = false
			this.editSender = false
			this.editReciever = false
			this.editRecieverAddress = false
		},
		handleTabItemClick(val) {

		},
		// 需要获取产品默认地址信息
		getDataList() {
			console.log(this.orderItem)
			queryproductaddress({
				visaId: this.dialogData.visaId
			}).then(res => {
				if (res.code == 1) {
					if (res.data && res.data.id) {
						this.defaultData = res.data
					} else {
						// this.$message.error('请先设置产品默认地址信息')
					}
				}
				console.log(res, 'res')
			})
		},
		// 获取用户快递信息
		getUserExpressData() {
			this.dataLoading = true

			console.log(this.orderItem)
			let data = {
				orderId: this.orderItem.orderId,
			}
			queryexpressorder(data).then(res => {
				console.log(res, '所有快递信息')
				if (res.code == 1 && res.data.length > 0) {
					let userData = res.data.filter(item => item.type == 1)
					let systemData = res.data.filter(item => item.type == 0)
					// if (userData.length > 0) {
					this.userExpressData = this.getLastExpressData(userData)
					// } else {
					this.userExpressData.phone = this.orderItem.userPhone
					this.userExpressData.recipient = this.orderItem.userName
					this.userExpressData.address = this.orderItem.userProvince + this.orderItem.userCity + this.orderItem.userDistrict + this.orderItem.userAddress

					// }
					this.systemExpressData = this.getLastExpressData(systemData)
					console.log(this.userExpressData, '用户快递信息')
					console.log(this.systemExpressData, '系统快递信息')
				}
			}).finally(() => {
				this.dataLoading = false
				this.$forceUpdate()
			})
		},
		// 选择最后一项快递信息
		getLastExpressData(dataList) {
			if (dataList.length == 0) {
				return {
					phone: '',
					recipient: '',
					exCompany: '',
					expressNo: '',
				}
			} else if (dataList.length == 1) {
				try {
					return { ...dataList[0], expressResult: dataList[0].expressData ? JSON.parse(dataList[0].expressData) : [] }
				} catch (error) {
					return { ...dataList[0], expressResult: [] }
				}
			} else {
				let maxId = dataList.reduce((max, item) => {
					return item.id > max ? item.id : max
				}, dataList[0].id)
				let maxItem = dataList.find(item => item.id === maxId)
				try {
					return { ...maxItem, expressResult: maxItem.expressData ? JSON.parse(maxItem.expressData) : [] }
				} catch (error) {
					return { ...maxItem, expressResult: [] }
				}
			}
		},
		courierChange(val, key) {
			console.log(val)
			let item = this.companySuoJson.find(item => item.value == val)
			this[key].exCompany = item.label
			this[key].exCompanyCode = item.value
		}
	},
}
</script>


<style lang="scss" scoped>
.info_box {
	display: flex;
	justify-content: space-between;
	margin-top: 20px;

	.info_circle {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		background: #409EFF;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 32px;
		font-weight: bold;
		color: #fff;
	}

	.info_text {
		display: flex;
		flex-direction: column;
	}

	.info_box_left {
		display: flex;
		align-items: center;
		gap: 20px;

		.info_box_text {
			display: flex;
			flex-direction: column;
			gap: 15px;
		}
	}

	.info_box_right {
		display: flex;
		flex-direction: column;
		gap: 15px;
	}
}

.dialog-member-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: -10px;

	.dialog-member-name {
		font-size: 18px;
		font-weight: bold;
	}

	.dialog-close {
		width: 25px;
		height: 25px;
		background: #e0e0e0;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		.el-icon-close {
			color: #fff;
			font-size: 16px;
		}
	}
}

.quan-num-add {
	.quan-num-input {
		margin: 12px 0;
	}

	.quan-num-add-item {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.quan-num-add-title {
			font-size: 16px;
			margin-top: 12px;
		}

		.quan-num-right {
			margin-left: 16px;
			color: #3888e9;
			cursor: pointer;
		}
	}
}
</style>

<style lang="scss">
.logisticsDialog-box {
	.el-dialog {
		border-radius: 12px;
		margin-top: 5vh !important;
	}

	.el-dialog__header {
		display: none;
	}

	.el-dialog__body {
		background: linear-gradient(180deg, #e7ecfb 0%, #f6f8fe 24%, #ffffff 100%);
		border-radius: 12px;
		box-sizing: border-box;
		overflow: hidden;
	}
}
</style>